import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider, Theme } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { system } from "@/theme";
import { store } from "@/store";
import { App } from "./App";
import "ol/ol.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <ChakraProvider value={system}>
        <Theme appearance="dark" style={{ height: "100%" }}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Theme>
      </ChakraProvider>
    </Provider>
  </StrictMode>
);
